module.exports = window["MaterialUI"].CardContent;